<template>
  <ListeReferentiel
    ref="liste"
    titre="Durées de traitement"
    icone="bi-clock-history"
    ressource="durees"
    tri-defaut="du.nom"
    :options-tri="{ Nom: 'du.nom' }"
    placeholder="Nom ou description…"
    unite="durée(s)"
    vide="Aucune durée enregistrée."
    :colonnes="5"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_DUREE_MEDICAMENT')"
    libelle-creer="Nouvelle durée"
    @creer="creation"
  >
    <template #entete>
      <th>Nom</th>
      <th class="d-none d-md-table-cell">Description</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: duree }">
      <td>{{ duree.nom }}</td>
      <td class="d-none d-md-table-cell">{{ duree.description || '—' }}</td>
      <td>
        <span :class="['badge', duree.isEnabled ? 'bg-success' : 'bg-secondary']">{{ duree.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_DUREE_MEDICAMENT', 'CONFIG_SUPPRESSION_DUREE_MEDICAMENT'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_DUREE_MEDICAMENT')"><a class="dropdown-item" href="#" @click.prevent="modifier(duree.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_DUREE_MEDICAMENT')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(duree)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeDureeMedicament',
  components: { ListeReferentiel },
  methods: {
    creation() {
      this.$router.push({ name: 'create_duree_medicament' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_duree_medicament', params: { id } });
    },
    supprimer(duree) {
      this.$refs.liste.supprimer({
        id: duree.id,
        titre: 'Supprimer la durée',
        message: `Supprimer la durée « ${duree.nom} » ?`,
        succes: 'Durée supprimée.',
      });
    },
  },
};
</script>
